// @flow
import { push } from 'react-router-redux';
import { getCurrentStep, isWizardPassed, WIZARD_STEPS } from '../reducers/wizardReducer';

const ME_URL = '/api/me';
const USER = '/api/u/:uid';
const BUY_SETUPS_URL = '/api/charge';
export const ME_UPDATE = 'me/UPDATE';
export const ME_UNAUTHORIZED = 'me/UNAUTHORIZED';
export const IS_CHARGING = 'me/CHARGING';
export const IS_CHARGED = 'me/CHARGED';

export const SETTINGS_SAVING = 'me/SETTINGS_SAVING';
export const SETTINGS_SAVED = 'me/SETTINGS_SAVED';

const { dataLayer } = window;

export const deleteUser = ({ uid }: { uid: string }) => {
  return (dispatch: Function) => {
    fetch(USER.replace(':uid', uid), {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => {
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data, status }) => {
        if (status === 200) {
          window.location.href = '/auth/logout';
        }
      });
  };
};

export const saveSettings = ({ email }: { email: string }) => {
  return (dispatch: Function) => {
    dispatch({ type: SETTINGS_SAVING });
    const USER_SETTINGS = {
      email
    };

    fetch(ME_URL, {
      method: 'PUT',
      body: JSON.stringify(USER_SETTINGS),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => {
        dispatch({ type: SETTINGS_SAVED });
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data, status }) => {
        if (status === 200) {
          dispatch(fetchMe());
        }
      });
  };
};

export const fetchMe = (cb?: Function) => {
  return (dispatch: Function) => {
    function checkWizardPassed(data) {
      const { pathname } = window.location;

      if (/^\/wizard\/.+/.test(pathname)) return;

      if (!data.isWizardDone && (data.projects && data.projects.length)) {
        const project = data.projects[0];
        const { wizard } = project;
        //TODO:  make it smart to choose what page to go
        if (!isWizardPassed({ passed: wizard })) {
          const redirectStep = getCurrentStep({ passed: wizard });
          if (!redirectStep) return;
          const redirectUrl = `/wizard/${redirectStep}`;

          dispatch(push(redirectUrl));
        }
      }
    }

    return fetch(ME_URL, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => {
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data, status }) => {
        if (status === 401) {
          const { pathname } = window.location;
          if (!pathname.startsWith('/login') && !pathname.startsWith('/_')) {
            dispatch(push('/login'));
          }
          return dispatch({
            type: ME_UNAUTHORIZED
          });
        }
        checkWizardPassed(data);

        dataLayer.push({ uid: data.id });
        dataLayer.push({ isNewUser: !data.isWizardDone });
        if (data.isNewUser) dataLayer.push({ event: 'conversion' });

        dispatch({
          type: ME_UPDATE,
          data
        });
        if (cb) cb.call(this, data);

        return data;
      });
  };
};

export const payForSetups = ({ token }: { token: string }) => {
  return (dispatch: Function) => {
    let fetchUrl = BUY_SETUPS_URL;
    dispatch({ type: IS_CHARGING });
    fetch(fetchUrl, {
      method: 'PUT',
      body: JSON.stringify({ token }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => {
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data, status }) => {
        dispatch(
          fetchMe(() => {
            dispatch({ type: IS_CHARGED });
          })
        );
      });
  };
};

export default {
  fetchMe,
  payForSetups,
  saveSettings,
  deleteUser
};



// WEBPACK FOOTER //
// ./src/actions/user.actions.js